import http from "./http";

// ✅ 玩法配置（你已经实现：/api/player/keno/config）
export const getKenoConfigApi = () => http.get("/api/player/keno/config");

// 最近已结算期（用于上一期total + 走势图）
export const getLastSettledIssuesApi = (limit = 30) =>
    http.get("/api/player/issue/last-settled", { params: { limit } });

// 当前期（用于倒计时、bettingAllowed）
export const getCurrentIssueApi = () => http.get("/api/player/issue/current");

// 开奖动画
export const revealStateApi = () => http.get("/api/player/issue/reveal/state");

